import React, { useEffect } from "react";
import styled from "styled-components";
import { useFormikContext } from 'formik';
import { usePrevious } from "react-use";
import { PrefillSelect } from "../../../../../../components/input/prefillSelect";
import { convertDateStringToDateObject } from "./utils/dateHelpersManageRepayments";
import { ValidationMessage } from './../../../../../../components/input/validationMessage';

const Wrapper = styled.div`
  flex: 1;
  position: relative;

  .validation-message {
    bottom: 0px;
  }
`

const useSelectWithDateValue = (name) => {
  const clientSideFieldName = "__clientsideonly__" + name;
  const { values, setFieldValue } = useFormikContext();
  const clientSideValue = values[clientSideFieldName];
  const previousClientSideValue = usePrevious(clientSideValue);
  useEffect(() => {
    if (previousClientSideValue !== clientSideValue) {
      setFieldValue(name, convertDateStringToDateObject(clientSideValue));
    }
  }, [clientSideValue, previousClientSideValue, name, setFieldValue]);

  return clientSideFieldName;
};

export const DatePickerManageRepayment = ({ title, className, placeholder, name, options }) => {
  const selectFieldName = useSelectWithDateValue(name);
  const { errors, touched } = useFormikContext();
  const errorMessages = errors? errors[name] : "";
  const errorMessage = errorMessages ? errorMessages.month : "";
  const isTouched = touched["__clientsideonly__" + name];

  return (
    <Wrapper>
      <PrefillSelect
        className={className}
        title={title}
        name={selectFieldName}
        options={options}
        placeholder={placeholder}
      />
    <ValidationMessage errorMessage={isTouched? errorMessage : ""}/>
    </Wrapper>
  );
};
